import script from "./TestInfoAnime.vue?vue&type=script&setup=true&lang=js"
export * from "./TestInfoAnime.vue?vue&type=script&setup=true&lang=js"

import "./TestInfoAnime.vue?vue&type=style&index=0&id=c4bfaf1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4bfaf1e"]])

export default __exports__